import { Component, OnInit } from '@angular/core';
import { PageInfoService } from 'projects/serviceportal/src/app/services/page-info.service';
import { PageInfo, BreadcrumbComponent } from 'shared';
import { ActivatedRoute } from '@angular/router';
import { EditIGridInstallationWizardComponent } from '../../components/edit-igrid-installation-wizard/edit-igrid-installation-wizard.component';
@Component({
    selector: 'app-create-edit-igrid-installation',
    templateUrl: './create-edit-igrid-installation.component.html',
    styleUrls: ['./create-edit-igrid-installation.component.scss'],
    imports: [BreadcrumbComponent, EditIGridInstallationWizardComponent],
})
export class CreateEditIGridInstallationComponent implements OnInit {
  public initialCompanyId: string;
  public initialFacilityId: string;
  public installationId: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly pageInfoService: PageInfoService,
  ) {}

  pageInfo: PageInfo;

  ngOnInit() {
    const [params, queryParams] = [this.route.snapshot.params, this.route.snapshot.queryParams];
    if (queryParams.companyId) {
      this.pageInfo = this.pageInfoService.createIGridInstallationPage(queryParams.companyId);
      this.initialCompanyId = queryParams.companyId;
    } else {
      this.pageInfo = this.pageInfoService.editIGridInstallationPage(params.facilityId, params.installationId);
    }
    if (queryParams.facilityId) {
      this.initialFacilityId = queryParams.facilityId;
    }
    if (params.installationId) {
      this.initialFacilityId = params.facilityId;
      this.installationId = params.installationId;
    }
  }
}
